import { render } from "./FamilyChannel.vue?vue&type=template&id=53462817&scoped=true"
import script from "./FamilyChannel.vue?vue&type=script&lang=js"
export * from "./FamilyChannel.vue?vue&type=script&lang=js"

import "./FamilyChannel.vue?vue&type=style&index=0&id=53462817&scoped=true&lang=css"

import exportComponent from "D:\\케이터링\\html(JW 가상화서버)\\justinfood\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53462817"]])

export default __exports__